import type { AxiosInstance } from "axios";
import { EventIdPublic } from "@shared/schemas/branded-id.schemas";

export function createEventUsersApi(apiClient: AxiosInstance) {
  // Returns unknown: the response is validated by the repo's schema parse,
  // not here. An axios response generic would be an unchecked cast, not validation.
  async function getEventUsers(eventIdPublic: EventIdPublic): Promise<unknown> {
    const response = await apiClient.get(
      `/api/v1/events/${encodeURIComponent(EventIdPublic.unwrap(eventIdPublic))}/users`,
    );
    return response.data;
  }

  return { getEventUsers };
}
